export default __webpack_public_path__ + "static/media/percent.448f1a30.svg";